// 3rd's
import { $fetch, type FetchOptions } from 'ofetch';

// locals
import AccessoryPageModule from '~/repository/modules/accessoryPage.module';
import BuybackModule from '~/repository/modules/buyback.module';
import CategoryModule from '~/repository/modules/category.module';
import CellPhonePageModule from '~/repository/modules/cellPhonePage.module';
import CheckoutModule from '~/repository/modules/checkout.module';
import CustomerModule from '~/repository/modules/customer.module';
import DeliveryAddressModule from '~/repository/modules/deliveryAddress.module';
import MobiltBankIdModule from '~/repository/modules/mobiltBankId.module';
import OrderReceiptModule from '~/repository/modules/orderReceipt.module';
import PaymentModule from '~/repository/modules/payment.module';
import PlanModule from '~/repository/modules/plan.module';
import PortingModule from '~/repository/modules/porting.module';
import ShoppingCartModule from '~/repository/modules/shoppingCart.module';
import TeliaPayModule from '~/repository/modules/teliaPay.module';
import TopicModule from '~/repository/modules/topic.module';
import shippingMethodModule from '~/repository/modules/ShippingMethod.module';
import AfterSalesOffersModule from '~/repository/modules/afterSalesOffers.module';
import InsuranceModule from '~/repository/modules/insurance.module';
import AggregatedProductModule from '~/repository/modules/aggregatedProduct.module';
import KlarnaModule from '~/repository/modules/Klarna.module';
import BDLVerificationModule from '~/repository/modules/bdlVerification.module';
import ConfirmRetailOrderModule from '~/repository/modules/confirmOrder.module';
import ManufacturerModule from '~/repository/modules/manufacturer.module';

interface IApiInstance {
  accessoryPage: AccessoryPageModule;
  afterSalesOffers: AfterSalesOffersModule;
  aggregateProductModule: AggregatedProductModule;
  bankId: MobiltBankIdModule;
  BuybackModule: BuybackModule;
  categoryModule: CategoryModule;
  cellPhonePage: CellPhonePageModule;
  checkout: CheckoutModule;
  CustomerModule: CustomerModule;
  deliveryAddress: DeliveryAddressModule;
  insuranceModule: InsuranceModule;
  klarnaModule: KlarnaModule;
  orderReceipt: OrderReceiptModule;
  PaymentModule: PaymentModule;
  planModule: PlanModule;
  PortingModule: PortingModule;
  shippingMethodModule: shippingMethodModule;
  ShoppingCartModule: ShoppingCartModule;
  teliaPay: TeliaPayModule;
  topicModule: TopicModule;
  bdlVerification: BDLVerificationModule;
  confirmRetailOrder: ConfirmRetailOrderModule;
  manufacturerModule: ManufacturerModule;
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  let apiBaseUrl = config.public.apiBaseUrl;
  if (!import.meta.client && config.feServerApiBaseUrl) {
    apiBaseUrl = config.feServerApiBaseUrl as string;
  }

  const fetchOptions: FetchOptions = {
    baseURL: apiBaseUrl as string,
  };

  // Create a new instance of $fecther with custom option
  const apiFetcher = $fetch.create(fetchOptions);

  // An object containing all repositories we need to expose
  const modules: IApiInstance = {
    accessoryPage: new AccessoryPageModule(apiFetcher, fetchOptions),
    afterSalesOffers: new AfterSalesOffersModule(apiFetcher, fetchOptions),
    aggregateProductModule: new AggregatedProductModule(
      apiFetcher,
      fetchOptions,
    ),
    bankId: new MobiltBankIdModule(apiFetcher, fetchOptions),
    BuybackModule: new BuybackModule(apiFetcher, fetchOptions),
    categoryModule: new CategoryModule(apiFetcher, fetchOptions),
    cellPhonePage: new CellPhonePageModule(apiFetcher, fetchOptions),
    checkout: new CheckoutModule(apiFetcher, fetchOptions),
    CustomerModule: new CustomerModule(apiFetcher, fetchOptions),
    deliveryAddress: new DeliveryAddressModule(apiFetcher, fetchOptions),
    insuranceModule: new InsuranceModule(apiFetcher, fetchOptions),
    klarnaModule: new KlarnaModule(apiFetcher, fetchOptions),
    orderReceipt: new OrderReceiptModule(apiFetcher, fetchOptions),
    PaymentModule: new PaymentModule(apiFetcher, fetchOptions),
    planModule: new PlanModule(apiFetcher, fetchOptions),
    PortingModule: new PortingModule(apiFetcher, fetchOptions),
    shippingMethodModule: new shippingMethodModule(apiFetcher, fetchOptions),
    ShoppingCartModule: new ShoppingCartModule(apiFetcher, fetchOptions),
    teliaPay: new TeliaPayModule(apiFetcher, fetchOptions),
    topicModule: new TopicModule(apiFetcher, fetchOptions),
    bdlVerification: new BDLVerificationModule(apiFetcher, fetchOptions),
    confirmRetailOrder: new ConfirmRetailOrderModule(apiFetcher, fetchOptions),
    manufacturerModule: new ManufacturerModule(apiFetcher, fetchOptions),
  };

  return {
    provide: {
      api: modules,
    },
  };
});
